/* Buy box behaviour. Lifted out of sections/ka-buybox.liquid so that file
   stays small enough for a single themeFilesUpsert; a truncated push there
   silently drops the schema. The gallery video marking stayed inline in the
   section because it has to run at parse time, before voltist.js.

   Root discovery changed on the way out. The inline version read
   document.currentScript.previousElementSibling, which is null for a
   deferred external script. This walks every [data-ka-buybox] on the page
   instead, so a second buy box on one page works and costs no extra bytes. */
(function () {
  function initOne(root) {
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---------- data ---------- */
    var variants = [];
    try {
      var dataEl = root.querySelector('[data-ka-variants]');
      variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    } catch (err) { variants = []; }

    var form = root.querySelector('[data-ka-form]');
    var idIn = root.querySelector('[data-ka-id]');
    var qtyIn = root.querySelector('[data-ka-qty]');
    var atc = root.querySelector('[data-ka-atc]');
    var atcText = root.getAttribute('data-ka-atc-text') || '';
    var atcPack = root.getAttribute('data-ka-atc-pack') || '';
    var atcSoldout = root.getAttribute('data-ka-atc-soldout') || '';
    var saveLabel = root.getAttribute('data-ka-save-label') || '';
    var perLabel = root.getAttribute('data-ka-per-label') || '';
    var moneyFmt = root.getAttribute('data-ka-money-format') || '{{amount}}';

    var swatches = Array.prototype.slice.call(root.querySelectorAll('[data-ka-swatch]'));
    var deals = Array.prototype.slice.call(root.querySelectorAll('[data-ka-deal]'));
    var bottles = Array.prototype.slice.call(root.querySelectorAll('[data-ka-bottle]'));
    var nameEl = root.querySelector('[data-ka-flavor-name]');
    var sticky = root.querySelector('[data-ka-sticky]');
    var stickyName = root.querySelector('[data-ka-sticky-name]');
    var stickyTotal = root.querySelector('[data-ka-sticky-total]');
    var stickyThumb = root.querySelector('[data-ka-sticky-thumb]');
    var stickyBtn = root.querySelector('[data-ka-sticky-btn]');
    /* the merchant's sticky label, restored after the sold-out and pending states */
    var stickyLabel = stickyBtn ? stickyBtn.textContent.trim() : '';

    var cur = null;
    (function () {
      var startId = idIn ? String(idIn.value) : '';
      var selDeal = deals.filter(function (d) { return d.hasAttribute('data-selected'); })[0];
      if (selDeal && selDeal.hasAttribute('data-fixed-id')) {
        var pressed = swatches.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0];
        startId = pressed ? pressed.getAttribute('data-id') : (variants[0] ? String(variants[0].id) : '');
      }
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === startId) { cur = variants[i]; break; }
      }
      if (!cur && variants.length) cur = variants[0];
    })();

    /* ---------- money ---------- */
    function group(intStr, sep) { return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
    function money(cents) {
      var n = Math.round(Number(cents) || 0) / 100;
      var m = moneyFmt.match(/\{\{\s*(\w+)\s*\}\}/);
      var key = m ? m[1] : 'amount';
      var out;
      var fixed = n.toFixed(2);
      var intPart = fixed.split('.')[0];
      var decPart = fixed.split('.')[1];
      switch (key) {
        case 'amount_no_decimals': out = group(String(Math.round(n)), ','); break;
        case 'amount_with_comma_separator': out = group(intPart, '.') + ',' + decPart; break;
        case 'amount_no_decimals_with_comma_separator': out = group(String(Math.round(n)), '.'); break;
        case 'amount_with_space_separator': out = group(intPart, ' ') + ',' + decPart; break;
        case 'amount_no_decimals_with_space_separator': out = group(String(Math.round(n)), ' '); break;
        case 'amount_with_apostrophe_separator': out = group(intPart, "'") + '.' + decPart; break;
        default: out = group(intPart, ',') + '.' + decPart;
      }
      return moneyFmt.replace(/\{\{\s*\w+\s*\}\}/, out).replace(/([.,])00(?!\d)/, '');
    }

    /* the same string without a dead decimal part. every price on the cards is a
       whole shekel, so .00 is two characters that only slow the eye down. the
       separator can be a dot or a comma depending on the shop's money format,
       and a real fraction such as .33 is left alone. */
    function moneyTrim(cents) { return money(cents).replace(/([.,])00(?!\d)/, ''); }

    /* ---------- deal math (mirror of the Liquid) ---------- */
    function calc(v, q, d) {
      var P = Number(v.price) || 0;
      var C = Number(v.compare_at_price);
      if (!C || C < P) C = P;
      var total = Math.round(P * q * (100 - d) / 100);
      var was = C * q;
      /* the per bottle number and the saving are both rounded to the shekel, matching
         the Liquid. ⛔ the saving used to be printed to the agora here, which only
         showed up on the strips page where the compare at prices are not whole. */
      return { total: total, was: was, save: Math.round((was - total) / 100) * 100,
               per: Math.round(total / q / 100) * 100 };
    }
    function setEmpty(el, empty) { if (el) el.toggleAttribute('data-empty', !!empty); }

    /* ---------- a tier bound to its own variant ----------
       Those rows are priced by the Liquid and renderDeals skips them, which is
       exactly why the plan discount used to reach the button and not the cards.
       The server strings are kept once, so switching the plan off restores what
       was rendered instead of a number this file recomputed. */
    /* ⭐ 23.9.2026: the price per day line (setting day_units). The Liquid prints
       it for the one time price, and it has to follow the plan discount exactly
       like the other numbers on the card, or a ticked club would show a per day
       figure that belongs to a different total. Floor, not round: a per day
       price may never read cheaper than the pack really works out to. */
    function paintDay(row, cents) {
      var el = row.querySelector('[data-ka-deal-day]');
      if (!el) return;
      var n = parseInt(el.getAttribute('data-days'), 10) || 0;
      if (n <= 0) return;
      var tpl = el.getAttribute('data-tpl') || '[מחיר]';
      el.textContent = tpl.replace('[מחיר]', money(Math.floor((Number(cents) || 0) / n)));
    }

    function paintFixed(row, noDisc) {
      var tot = row.querySelector('[data-ka-deal-total]');
      var per = row.querySelector('[data-ka-deal-per-num]');
      var was = row.querySelector('[data-ka-deal-was]');
      var save = row.querySelector('[data-ka-deal-save]');
      var pill = row.querySelector('[data-ka-deal-pill]');
      if (!row.kaOrig) {
        row.kaOrig = {
          tot: tot ? tot.textContent : '',
          per: per ? per.textContent : '',
          save: save ? save.textContent : '',
          wasEmpty: was ? was.hasAttribute('data-empty') : true,
          pillEmpty: pill ? pill.hasAttribute('data-empty') : true
        };
      }
      var pct = planPct();
      row.toggleAttribute('data-plan', pct > 0);
      if (pct <= 0) {
        if (tot) tot.textContent = row.kaOrig.tot;
        if (per) per.textContent = row.kaOrig.per;
        if (save) save.textContent = row.kaOrig.save;
        setEmpty(was, row.kaOrig.wasEmpty);
        setEmpty(pill, row.kaOrig.pillEmpty);
        paintDay(row, row.getAttribute('data-total'));
        return;
      }
      var base = Number(row.getAttribute('data-total')) || 0;
      var wasC = Number(row.getAttribute('data-was')) || 0;
      /* ⛔ data-pack and not data-qty: a pack sold as its own variant is one
         cart line, so data-qty is 1 while data-pack still says three or five,
         and the headline is a price per bottle. */
      var pack = parseInt(row.getAttribute('data-pack'), 10) || 1;
      var dTot = Math.round(base * (100 - pct) / 100);
      if (tot) tot.textContent = moneyTrim(dTot);
      
      if (per) per.textContent = moneyTrim(noDisc ? dTot : Math.round(dTot / pack / 100) * 100);
      if (save) save.textContent = moneyTrim(Math.round((wasC - dTot) / 100) * 100);
      setEmpty(was, wasC <= dTot);
      setEmpty(pill, wasC <= dTot);
      paintDay(row, dTot);
    }

    function renderDeals() {
      if (!cur) return;
      var noDisc = !!(root.querySelector('.ka-deals') && root.querySelector('.ka-deals').hasAttribute('data-no-disc'));
      deals.forEach(function (row) {
        if (row.hasAttribute('data-fixed-id')) { paintFixed(row, noDisc); return; }
        var q = parseInt(row.getAttribute('data-qty'), 10) || 1;
        var d = parseInt(row.getAttribute('data-disc'), 10) || 0;
        var r = calc(cur, q, d);
        /* ⛔ the base, never the plan price: currentTotal() reads this attribute
           and applies the plan discount itself, so writing the discounted
           number here would take it off twice. */
        row.setAttribute('data-total', r.total);
        /* the plan discount applies to what the card SHOWS, so the tier and the
           button never disagree. The struck price stays the compare at, which is
           what "the original price stays" means on the card. */
        var pp = planPct();
        var dTot = r.total, dPer = r.per, dSave = r.save;
        if (pp > 0) {
          dTot = Math.round(r.total * (100 - pp) / 100);
          /* ⭐ rounded to the shekel, the same as calc() does without a plan */
          dPer = Math.round(dTot / q / 100) * 100;
          dSave = Math.round((r.was - dTot) / 100) * 100;
        }
        row.toggleAttribute('data-plan', pp > 0);
        var tot = row.querySelector('[data-ka-deal-total]');
        var was = row.querySelector('[data-ka-deal-was]');
        var per = row.querySelector('[data-ka-deal-per-num]');
        var pill = row.querySelector('[data-ka-deal-pill]');
        var save = row.querySelector('[data-ka-deal-save]');
        if (tot) tot.textContent = moneyTrim(dTot);
        if (was) { was.querySelector('bdi').textContent = moneyTrim(r.was); setEmpty(was, r.was <= dTot); }
        /* headline mirrors the server: per bottle when a real discount exists,
           otherwise the pack total, so the three cards never show one number */
        if (per) per.textContent = moneyTrim(noDisc ? dTot : dPer);
        if (pill) { if (save) save.textContent = moneyTrim(dSave); setEmpty(pill, dSave <= 0); }
        paintDay(row, dTot);
      });
      /* fallback price row (no deal blocks) */
      var priceEl = root.querySelector('[data-ka-price]');
      if (priceEl) {
        var C = Number(cur.compare_at_price) || 0, P = Number(cur.price) || 0;
        priceEl.textContent = money(P);
        var cmp = root.querySelector('[data-ka-compare]');
        if (cmp) { cmp.querySelector('bdi').textContent = money(C); setEmpty(cmp, C <= P); }
        var badge = root.querySelector('[data-ka-badge]');
        var pctEl = root.querySelector('[data-ka-badge-pct]');
        var pct = C > P ? Math.round((C - P) * 100 / C) : 0;
        if (pctEl) pctEl.textContent = pct + '%';
        setEmpty(badge, pct <= 0);
      }
    }

    function selectedDeal() {
      return deals.filter(function (d) { return d.hasAttribute('data-selected'); })[0] || null;
    }
    /* the plan discount, or 0 when the shopper is on the one time option.
       vipOpts is declared further down, so this guards against being called
       before that line runs. */
    function planPct() {
      if (!vipOpts) return 0;
      var on = vipOpts.filter(function (x) { return x.hasAttribute('data-selected'); })[0];
      if (!on || on.getAttribute('data-ka-vip-opt') !== 'sub') return 0;
      return Number(on.getAttribute('data-ka-plan-pct')) || 0;
    }
    function currentTotal() {
      var row = selectedDeal();
      var base = row ? (Number(row.getAttribute('data-total')) || 0)
                     : (cur ? Number(cur.price) || 0 : 0);
      var pct = planPct();
      if (pct > 0) return Math.round(base * (100 - pct) / 100);
      return base;
    }
    function currentQty() {
      var row = selectedDeal();
      return row ? (parseInt(row.getAttribute('data-qty'), 10) || 1) : 1;
    }
    /* how many bottles the tier stands for, which is not what goes to the cart:
       a pack sold as its own variant is one line at its own price, so data-qty
       is 1 while data-pack still says three or five for the button copy */
    function packSize() {
      var row = selectedDeal();
      if (!row) return 1;
      return parseInt(row.getAttribute('data-pack'), 10)
        || parseInt(row.getAttribute('data-qty'), 10) || 1;
    }
    function currentAvailable() {
      var row = selectedDeal();
      if (row && row.hasAttribute('data-fixed-id')) return row.getAttribute('data-fixed-available') === 'true';
      return cur ? !!cur.available : true;
    }

    function syncAtc() {
      if (!atc) return;
      var q = currentQty();
      var ok = currentAvailable();
      if (!ok) {
        atc.disabled = true;
        atc.textContent = atcSoldout;
      } else {
        atc.disabled = false;
        var pk = packSize();
        var label = pk > 1 ? atcPack.replace('[n]', pk) : atcText;
        /* rebuilt from scratch every time: voltist.js writes its pending text straight onto
           the button, which wipes these spans, and this is what puts them back */
        atc.innerHTML = '';
        var l = document.createElement('span');
        l.className = 'ka-atc__label';
        l.textContent = label;
        atc.appendChild(l);
        var p = document.createElement('span');
        p.className = 'ka-atc__price';
        var b = document.createElement('bdi');
        b.textContent = money(currentTotal());
        p.appendChild(b);
        atc.appendChild(p);
      }
      /* mirror the main ATC state into the sticky button (the price lives in the sticky total, not in the label) */
      if (stickyBtn && !stickyPending) {
        stickyBtn.disabled = !ok;
        stickyBtn.textContent = ok ? stickyLabel : atcSoldout;
      }
      if (stickyTotal) stickyTotal.textContent = money(currentTotal());
    }

    /* ---------- sticky button pending state ----------
       voltist.js writes 'מוסיף...' onto form.querySelector('[type=submit]'), which is the MAIN ATC,
       offscreen whenever the sticky bar shows. Mirror the pending state onto the sticky button so a
       second thumb tap cannot add the pack twice. Set from the form's submit event, not the click:
       disabling a submit button inside its own click handler cancels the implicit submission. */
    var stickyPending = false, stickyTimer = null;
    function stickyRestore() {
      if (!stickyPending) return;
      stickyPending = false;
      clearTimeout(stickyTimer);
      if (stickyBtn) {
        stickyBtn.textContent = stickyBtn.dataset.label || stickyLabel;
        delete stickyBtn.dataset.label;
        stickyBtn.disabled = false;
      }
      syncAtc();
    }
    function stickyPend() {
      if (stickyPending || !stickyBtn) return;
      stickyPending = true;
      stickyBtn.dataset.label = stickyBtn.textContent;
      stickyBtn.textContent = 'מוסיף...';
      stickyBtn.disabled = true;
      clearTimeout(stickyTimer);
      /* safety: voltist.js falls back to a native form.submit() on error, which fires no event */
      stickyTimer = setTimeout(stickyRestore, 6000);
    }
    if (form && stickyBtn) {
      /* sticky click: defer one tick so the button is still enabled when its implicit submission runs */
      stickyBtn.addEventListener('click', function () {
        if (stickyBtn.disabled) return;
        setTimeout(stickyPend, 0);
      });
      form.addEventListener('submit', stickyPend);
      document.addEventListener('cart:update', stickyRestore);
    }

    function syncHidden() {
      var row = selectedDeal();
      if (idIn) {
        if (row && row.hasAttribute('data-fixed-id')) idIn.value = row.getAttribute('data-fixed-id');
        else if (cur) idIn.value = cur.id;
      }
      if (qtyIn) qtyIn.value = currentQty();
    }

    /* ---------- deals ---------- */
    function selectDeal(row) {
      deals.forEach(function (d) { d.removeAttribute('data-selected'); });
      row.setAttribute('data-selected', '');
      var radio = row.querySelector('input[type=radio]');
      if (radio) radio.checked = true;
      syncHidden();
      syncAtc();
    }
    deals.forEach(function (row) {
      row.addEventListener('click', function () { selectDeal(row); });
      var radio = row.querySelector('input[type=radio]');
      if (radio) radio.addEventListener('change', function () { if (radio.checked) selectDeal(row); });
    });

    /* ---------- gallery ---------- */
    var track = root.querySelector('[data-ka-track]');
    var thumbsWrap = root.querySelector('[data-ka-thumbs]');
    var thumbs = thumbsWrap ? Array.prototype.slice.call(thumbsWrap.children) : [];
    var snapTimer = null;
    function scrollTrackTo(slide) {
      if (!track || !slide) return;
      var delta = slide.getBoundingClientRect().left - track.getBoundingClientRect().left;
      if (Math.abs(delta) < 2) return;
      /* horizontal only: never scrollIntoView, which would also move the page vertically */
      track.style.scrollSnapType = 'none';
      clearTimeout(snapTimer);
      try {
        track.scrollTo({ left: track.scrollLeft + delta, behavior: reduced ? 'auto' : 'smooth' });
      } catch (err) { track.scrollLeft = track.scrollLeft + delta; }
      snapTimer = setTimeout(function () { track.style.scrollSnapType = ''; }, reduced ? 50 : 450);
    }
    function slideByMedia(mediaId) {
      if (!track || !mediaId) return null;
      return track.querySelector('[data-media-id="' + String(mediaId).replace(/"/g, '') + '"]');
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
        scrollTrackTo(track && track.children[i]);
      });
    });
    /* ⭐ החצים משתמשים ב-scrollTrackTo הקיים, שמחשב דלתא מ-getBoundingClientRect
       ולכן הוא נכון גם ב-RTL, שם scrollLeft שלילי ומטעה.
       ⭐ גלילה מעגלית: מהאחרון קדימה חוזרים לראשון. */
    var navBtns = root.querySelectorAll('[data-ka-gal-nav]');
    function currentIndex() {
      if (!track || !track.children.length) return 0;
      var w = track.children[0].getBoundingClientRect().width + 16;
      if (!w) return 0;
      return Math.round(Math.abs(track.scrollLeft) / w);
    }
    Array.prototype.forEach.call(navBtns, function (btn) {
      btn.addEventListener('click', function () {
        if (!track || !track.children.length) return;
        var n = track.children.length;
        var step = parseInt(btn.getAttribute('data-ka-gal-nav'), 10) || 1;
        var i = (currentIndex() + step + n) % n;
        scrollTrackTo(track.children[i]);
        thumbs.forEach(function (b, bi) {
          b.setAttribute('aria-current', bi === i ? 'true' : 'false');
        });
      });
    });

    if (track && thumbs.length) {
      var st;
      track.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () {
          var w = track.children[0] ? track.children[0].getBoundingClientRect().width + 16 : 0;
          if (!w) return;
          var i = Math.round(Math.abs(track.scrollLeft) / w);
          thumbs.forEach(function (b, bi) { b.setAttribute('aria-current', bi === i ? 'true' : 'false'); });
        }, 80);
      }, { passive: true });
    }

    /* ---------- flavors ----------
       The cards live in a horizontal snap row on a phone, so the chosen card can start off
       screen. This nudges the ROW only, never the page: scrollLeft on the row itself, the
       same technique the gallery uses, so the document never jumps under the reader. */
    var flavorRow = root.querySelector('[data-ka-flavor-row]');
    function revealFlavor(btn, smooth) {
      if (!flavorRow || !btn) return;
      if (flavorRow.scrollWidth <= flavorRow.clientWidth + 2) return;
      var rowBox = flavorRow.getBoundingClientRect();
      var btnBox = btn.getBoundingClientRect();
      var pad = 12;
      var delta = 0;
      if (btnBox.left < rowBox.left + pad) delta = btnBox.left - rowBox.left - pad;
      else if (btnBox.right > rowBox.right - pad) delta = btnBox.right - rowBox.right + pad;
      if (!delta) return;
      try {
        flavorRow.scrollTo({ left: flavorRow.scrollLeft + delta, behavior: (smooth && !reduced) ? 'smooth' : 'auto' });
      } catch (err) { flavorRow.scrollLeft = flavorRow.scrollLeft + delta; }
    }

    function selectFlavor(btn, opts) {
      opts = opts || {};
      var id = btn.getAttribute('data-id');
      var v = null;
      for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === String(id)) { v = variants[i]; break; } }
      if (!v) return;
      cur = v;
      swatches.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      if (nameEl) nameEl.textContent = v.title;
      if (stickyName) stickyName.textContent = v.title;
      var capColor = btn.getAttribute('data-cap') || '';
      if (sticky) sticky.style.setProperty('--ka-cap', capColor);
      var dealsWrap = root.querySelector('[data-ka-deals]');
      if (dealsWrap) dealsWrap.style.setProperty('--ka-cap', btn.getAttribute('data-key') === 'fallback' ? 'var(--sp-accent, #7c60db)' : capColor);
      if (stickyThumb && v.featured_image && v.featured_image.src) {
        stickyThumb.src = v.featured_image.src.split('?')[0] + '?width=120';
      }
      /* the repeated bottles in the pack cards follow the chosen flavour, unless the merchant
         picked a dedicated pack photo for that card (those images carry no data-ka-bottle) */
      if (v.featured_image && v.featured_image.src) {
        var bsrc = v.featured_image.src.split('?')[0] + '?width=220';
        bottles.forEach(function (img) { img.src = bsrc; });
      }
      renderDeals();
      syncHidden();
      syncAtc();
      var slide = slideByMedia(btn.getAttribute('data-media'));
      if (slide) scrollTrackTo(slide);
      if (!opts.silent && window.history && history.replaceState) {
        try { history.replaceState(null, '', '?variant=' + v.id); } catch (err) {}
      }
    }
    swatches.forEach(function (b) {
      b.addEventListener('click', function () { selectFlavor(b); revealFlavor(b, true); });
    });
    /* on load, put the already chosen card where it can be seen */
    (function () {
      var pressed = swatches.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0];
      if (pressed) revealFlavor(pressed, false);
    })();

    /* ---------- VIP: the real subscription selector ----------
       The selling_plan input is what makes Shopify open a subscription
       contract. It stays disabled on the one time option, because posting an
       empty selling_plan fails the add to cart instead of ignoring it. */
    var planInput = root.querySelector('[data-ka-plan]');
    var vipOpts = Array.prototype.slice.call(root.querySelectorAll('[data-ka-vip-opt]'));

    function vipApply(o, on) {
      if (on) o.setAttribute('data-selected', '');
      else o.removeAttribute('data-selected');
      if (planInput) {
        var pid = o.getAttribute('data-ka-plan-id') || '';
        if (on && o.getAttribute('data-ka-vip-opt') === 'sub' && pid) {
          planInput.value = pid;
          planInput.disabled = false;
        } else {
          planInput.value = '';
          planInput.disabled = true;
        }
      }
      /* ⛔ the cards repaint too. Without this the button showed the plan price
         and the selected tier still showed the one time price. */
      renderDeals();
      syncAtc();
    }

    vipOpts.forEach(function (o) {
      var box = o.querySelector('input[type=checkbox]');
      if (box) {
        /* ⛔ change and not click. The label already flips the box by itself, so
           a click handler here would flip it a second time and cancel it out. */
        box.addEventListener('change', function () { vipApply(o, box.checked); });
        return;
      }
      /* the older two option shape, still supported for a store that wants it */
      o.addEventListener('click', function () {
        vipOpts.forEach(function (x) { x.removeAttribute('data-selected'); });
        var radio = o.querySelector('input[type=radio]');
        if (radio) radio.checked = true;
        vipApply(o, true);
      });
    });

    /* ---------- quotes slider ----------
       Movement is the browser's own scroll snap, so there is nothing here that
       drags. This only lights the right dot and lets a dot scroll to its card.
       ⛔ the active index comes from which card centre is nearest the track
       centre, never from scrollLeft: in RTL Chrome reports it as a negative
       number and Safari as a positive one that counts down, so any arithmetic
       on it is wrong in one of the two. */
    (function () {
      var qs = root.querySelector('[data-ka-qs]');
      if (!qs) return;
      var track = qs.querySelector('[data-ka-qs-track]');
      if (!track) return;
      var cards = Array.prototype.slice.call(track.children);
      var dots = Array.prototype.slice.call(qs.querySelectorAll('[data-ka-qs-dot]'));
      if (cards.length < 2 || !dots.length) return;

      function activeIndex() {
        var r = track.getBoundingClientRect();
        var mid = r.left + r.width / 2;
        var best = 0, bd = Infinity;
        cards.forEach(function (c, n) {
          var cr = c.getBoundingClientRect();
          var d = Math.abs(cr.left + cr.width / 2 - mid);
          if (d < bd) { bd = d; best = n; }
        });
        return best;
      }
      function paint() {
        var i = activeIndex();
        dots.forEach(function (d, n) { d.toggleAttribute('data-on', n === i); });
      }
      var raf = 0;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = 0; paint(); });
      }, { passive: true });
      var reducedQ = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function goCard(n) {
        var c = cards[n];
        if (!c) return;
        /* horizontal only: never scrollIntoView, which would also move the page
           vertically and yank a shopper who has scrolled past this section. */
        var delta = c.getBoundingClientRect().left - track.getBoundingClientRect().left;
        delta -= (track.clientWidth - c.offsetWidth) / 2;
        if (Math.abs(delta) < 2) return;
        try {
          track.scrollTo({ left: track.scrollLeft + delta, behavior: reducedQ ? 'auto' : 'smooth' });
        } catch (err) { track.scrollLeft = track.scrollLeft + delta; }
      }

      dots.forEach(function (d, n) {
        d.addEventListener('click', function () { goCard(n); });
      });
      paint();

      /* a slow rotation so the shopper notices there is more than one card.
         it stops for good on the first touch, and never starts for a visitor
         who asked for less motion. */
      if (!reducedQ) {
        var timer = setInterval(function () {
          if (document.hidden) return;
          /* nothing to notice while the section is off screen */
          var tv = track.getBoundingClientRect();
          if (tv.bottom < 0 || tv.top > (window.innerHeight || 0)) return;
          var n = (activeIndex() + 1) % cards.length;
          goCard(n);
        }, 6000);
        ['pointerdown', 'touchstart', 'keydown'].forEach(function (ev) {
          qs.addEventListener(ev, function () { clearInterval(timer); }, { once: true, passive: true });
        });
      }
    })();

    /* ---------- the deals guide ----------
       Its panel lives outside the <details> so the heading row can stay a
       plain flex row, so the open state has to be mirrored onto it by hand.
       Driven by a data attribute rather than the hidden attribute, because
       hidden loses to any display rule that touches the element. */
    var guide = root.querySelector('.ka-guide');
    var guideBody = root.querySelector('[data-ka-guide-body]');
    if (guide && guideBody) {
      var syncGuide = function () { guideBody.toggleAttribute('data-open', guide.open); };
      guide.addEventListener('toggle', syncGuide);
      syncGuide();
    }

    /* ---------- the guide as one question row ----------
       The heading and the toggle used to sit side by side, a title plus a small
       link next to it. One line that is itself the question and opens like a
       FAQ row reads better, so the heading moves into the summary and the old
       link text goes away. The panel keeps its open state from syncGuide, and
       the stylesheet only restyles a head that carries the attribute set here,
       so a page where this script did not run keeps the old layout. */
    if (guide && guideBody) {
      var qHead = root.querySelector('.ka-deals__head');
      var qSummary = guide.querySelector('.ka-guide__toggle');
      var qTitle = qHead ? qHead.querySelector('.ka-deals__title') : null;
      if (qHead && qSummary && qTitle) {
        var qLabel = qSummary.querySelector('span');
        if (qLabel) qLabel.remove();
        qSummary.insertBefore(qTitle, qSummary.firstChild);
        qHead.setAttribute('data-ka-qrow', '');
        guideBody.setAttribute('data-ka-qrow', '');
      }
    }

    /* ---------- accordion ----------
       Every row ships closed, on every width. The first row used to open
       itself on desktop, which meant the composition row was expanded before
       anyone asked for it and the page opened mid sentence. */
    Array.prototype.forEach.call(root.querySelectorAll('[data-ka-acc] details'), function (d) {
      d.open = false;
    });

    /* ---------- ATC label re-sync after voltist.js restores its captured text ---------- */
    document.addEventListener('cart:update', function () { setTimeout(syncAtc, 2600); });

    /* ---------- sticky mobile bar ---------- */
    var atcVisible = true, atcPassed = false, drawerOpen = false;
    var mqMobile = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
    function syncSticky() {
      if (!sticky) return;
      var on = atcPassed && !atcVisible && !drawerOpen && (!mqMobile || mqMobile.matches);
      sticky.toggleAttribute('data-on', on);
      sticky.toggleAttribute('inert', !on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.body.classList.toggle('ka-sticky-on', on);
    }
    if (sticky && atc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          atcVisible = e.isIntersecting;
          /* Only count the button as passed once it has left through the TOP.
             The old test was simply "not on screen", which is also true while
             the button is still below the fold, so the bar greeted people who
             had not yet reached the buy box and then vanished as they arrived.
             boundingClientRect.top < 0 is the difference between behind you
             and ahead of you. */
          if (!e.isIntersecting) {
            atcPassed = e.boundingClientRect.top < 0;
          } else {
            atcPassed = false;
          }
        });
        syncSticky();
      }, { rootMargin: '0px 0px -56px 0px', threshold: 0 });
      io.observe(atc);
      /* the observer only fires when the button crosses the edge, so a scroll
         that starts or ends mid page needs the state recomputed by hand */
      function measure() {
        var r = atc.getBoundingClientRect();
        var visible = r.bottom > 0 && r.top < (window.innerHeight - 56);
        atcVisible = visible;
        atcPassed = !visible && r.top < 0;
        syncSticky();
      }
      var scrollT;
      window.addEventListener('scroll', function () {
        clearTimeout(scrollT);
        scrollT = setTimeout(measure, 80);
      }, { passive: true });
      window.addEventListener('resize', function () {
        clearTimeout(scrollT);
        scrollT = setTimeout(measure, 120);
      }, { passive: true });
      if (mqMobile && mqMobile.addEventListener) mqMobile.addEventListener('change', syncSticky);

      /* cart drawer open/closed */
      var watchedDialog = null;
      function watchDrawer() {
        if (watchedDialog) return;
        var dlg = document.querySelector('cart-drawer-component dialog.cart-drawer__dialog');
        if (!dlg) return;
        watchedDialog = dlg;
        drawerOpen = dlg.hasAttribute('open');
        new MutationObserver(function () { drawerOpen = dlg.hasAttribute('open'); syncSticky(); })
          .observe(dlg, { attributes: true, attributeFilter: ['open'] });
        syncSticky();
      }
      watchDrawer();
      document.addEventListener('cart:update', function () { setTimeout(watchDrawer, 50); });
      /* the bar deliberately stays put while a FAQ summary has focus: hiding it there removed
         body.ka-sticky-on too, and the document lost 64px of height on every question tap */
    }
    var jump = root.querySelector('[data-ka-sticky-jump]');
    if (jump) {
      jump.addEventListener('click', function () {
        var target = form || root;
        target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
        var first = swatches[0];
        if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (err) {} }, 500);
      });
    }

    /* ---------- initial paint ---------- */
    syncHidden();
    syncAtc();
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ka-buybox]'), function (root) {
      if (root.getAttribute('data-ka-ready') === '1') return;
      root.setAttribute('data-ka-ready', '1');
      try { initOne(root); } catch (err) { /* one broken buy box must not kill the others */ }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  /* the theme editor swaps section markup in and out without a page load */
  document.addEventListener('shopify:section:load', initAll);
})();
